<template>
    <Transition>
        <div style="margin-right: 10px;" v-if="candidate">
        <div class="form container px-2">
        <h5><b>J. Comments/Confirmation made by Head of Department on claims made by staff</b></h5>

        <div class="d-flex flex-wrap mb-3">
            <span class="flex-fill p-0">
                <textarea v-model="claimsVerification" rows="5" type="text" class="form-control pb-0" disabled></textarea>
            </span>
        </div>

        <h5 class="mt-5"><b>K. General Comments/Assessment by Head of Department:</b></h5>

        <div class="d-flex flex-wrap mb-3">
            <span class="flex-fill p-0">
                <textarea v-model="hodComments" rows="5" type="text" class="form-control pb-0" disabled></textarea>
            </span>
        </div>

        <div class="text-start my-5">
            <div v-if="!hodApproval && hodCommentDate" class="mb-4">
                <h6><b>Your HOD doesn't approve you to submit to the Dean.</b></h6>
                <small>You are expected to make corrections and resubmit to the HOD.</small>
            </div>
            <div v-if="hodApproval" class="mb-4">
                <h6><b>Your HOD approves you to submit to the Dean.</b></h6>
                <small>You can click the Submit to Dean button below.</small>
            </div>
        </div>
        
        <div v-if="hodCommentDate" class="d-flex flex-wrap mx-4">
            <span class="pe-0 me-2">
                <p class="mb-0"><b>
                        HOD's comment date:
                    </b></p>
            </span>
            <span class="p-0">
                <p>{{ hodCommentDate }}</p>
            </span>
        </div>
        <div v-if="dateOfSubmission" class="d-flex flex-wrap mx-4">
            <span class="pe-0 me-2">
                <p class="mb-0"><b>
                    Submission to HOD date (Most recent):
                    </b></p>
            </span>
            <span class="p-0">
                <p>{{ dateOfSubmission }}</p>
            </span>
        </div>
        <div v-if="hodEmail" class="d-flex flex-wrap mb-3 mx-4">
            <span class="pe-0 me-2">
                <p class="mb-0">
                    <b>
                        HOD's email:
                    </b>
                </p>
            </span>
            <span class="p-0">{{ hodEmail }}</span>
        </div>
        <div v-if="submitToDeanDate" class="d-flex flex-wrap mb-3 mx-4">
            <span class="pe-0 me-2">
                <p class="mb-0">
                    <b>
                        Submission to Dean date (Most recent):
                    </b>
                </p>
            </span>
            <span class="p-0">{{ submitToDeanDate }}</span>
        </div>
        <div v-if="deanEmail" class="d-flex flex-wrap mx-4">
            <span class="pe-0 me-2">
                <p class="mb-0">
                    <b>
                        Dean's email:
                    </b>
                </p>
            </span>
            <span class="p-0">{{ deanEmail }}</span>
        </div>

        <div class="d-flex flex-row-reverse my-5">
            <router-link v-if="deanCommentDate && hodApproval" class="me-3" to="/sectionl">
                <button type="button" class="btn btn-success">View Dean's Comment</button>
            </router-link>
            <button v-if="!deanApproval && hodApproval && !deanCommentDate" type="button" class="btn btn-success" data-bs-toggle="modal" data-bs-target="#staticBackdrop">Submit to Dean</button>
            <button v-if="!hodApproval && hodCommentDate" type="button" class="btn btn-success" data-bs-toggle="modal" data-bs-target="#staticBackdrop1">Resubmit to HOD</button>
            <router-link class="me-3" to="/sectioni">
                <button type="button" class="btn btn-success">Previous Section</button>
            </router-link>
        </div>

        <!--Resubmit to HOD modal-->
        <div class="modal fade" id="staticBackdrop1" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Resubmit to HOD</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="container mb-4">
                            <span class="flex-fill p-0">
                                <input type="text" class="form-control pb-0" name="deanEmail" v-model="newHodEmail" placeholder="Head of Department Email">
                            </span>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="resubmitToHOD()" type="button" class="btn btn-success" data-bs-dismiss="modal">Resubmit</button>
                    </div>
                </div>
            </div>
        </div>

        <!--Submit to Dean modal-->
        <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Submit to Dean</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="container mb-4">
                            <span class="flex-fill p-0">
                                <input type="text" class="form-control pb-0" name="deanEmail" v-model="deanEmail" placeholder="Dean Email">
                            </span>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="submitToDean()" type="button" class="btn btn-success" data-bs-dismiss="modal">Submit</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
</Transition>
</template>
<script>
import DataService from '../../services/dataservice';

export default {
    name: 'sectionJ&K',
    emits: ['toggleLoader', 'setSection', 'submitted'],
    data() {
        return { candidate: '',
            claimsVerification: '',
            hodComments: '',
            dateOfSubmission: '',
            hodCommentDate: '',
            hodApproval: false,
            hodEmail: '',
            newHodEmail: '',
            deanEmail: '',
            deanComments: '',
            deanCommentDate: '',
            deanApproval: '',
            submitToDeanDate: ''
        }
    },
    mounted() {
        this.$emit('setSection', 'Section J & K');
        this.setData()
    },
    methods: {
        async resubmitToHOD(){
            this.$emit('toggleLoader');

            const date = new Date();

            if(this.newHodEmail) {
                var regex = /^[\w\-\.\+]+\@[a-zA-Z0-9\. \-]+\.[a-zA-z0-9]{2,4}$/;
                if (this.newHodEmail.match(regex) == null){
                    alert ('Enter a correct email');
                    this.$emit('toggleLoader');
                    return
                }

                var dataDetails = {
                    hodEmail: this.newHodEmail.trim().toLowerCase(),
                    submitToHODDate: date.getUTCDate() + '/' + (Number(date.getUTCMonth()) + 1) + '/' + date.getUTCFullYear() 
                }

                const res = await DataService.saveData(dataDetails);

                if (res) {
                    alert('Successfully resubmitted to HOD');
                    this.hodEmail = dataDetails.hodEmail;
                }
            } else {
                alert("Enter your HOD's email")
            }
            this.$emit('toggleLoader');
        },
        async submitToDean(){
            this.$emit('toggleLoader');

            const date = new Date();

            if (this.deanEmail) {
                var regex = /^[\w\-\.\+]+\@[a-zA-Z0-9\. \-]+\.[a-zA-z0-9]{2,4}$/;
                if (this.deanEmail.match(regex) == null){
                    alert ('Enter a correct email');
                    this.$emit('toggleLoader');
                    return
                }

                var dataDetails = {
                    submitToDeanDate: date.getUTCDate() + '/' + (Number(date.getUTCMonth()) + 1) + '/' + date.getUTCFullYear(),
                    deanEmail: this.deanEmail.trim().toLowerCase(),
                }

                const res = await DataService.saveData(dataDetails);

                if (res) {
                    alert("You have successfully submitted your appraisal documents to your Dean for certification. Inform them to check their email and inform you when they have certified you. After your Dean's certification, you still need to make your final submission for appraisal in Section L.");
                    this.submitToDeanDate = dataDetails.submitToDeanDate;
                }
            } else {
                alert("Enter your Dean's email")
            }

            this.$emit('toggleLoader');
        },
        async setData() {
            window.scrollTo({ top: 0, behavior: 'smooth' });

            this.$emit('toggleLoader');

            const date = new Date();

            const candidate = await DataService.getCandidate(JSON.parse(window.localStorage['user'])._id);

            if (candidate) { 
                if ((candidate.staffType == "Junior Non-academic") || (candidate.staffType == "Senior Non-academic")) {
                    this.$emit('toggleLoader');
                    this.$router.push({ path: `/section1` });
                    return
                }
                this.$emit('submitted', candidate.submitted);
                this.candidate = candidate;
                this.claimsVerification = candidate.hodComments ? candidate.hodComments.claimsVerification : '';
                this.hodComments = candidate.hodComments ? candidate.hodComments.comment : '';
                this.dateOfSubmission = candidate.submitToHODDate ? candidate.submitToHODDate : '';
                this.hodCommentDate = candidate.hodComments ? candidate.hodComments.date : '';
                this.hodApproval = candidate.hodComments ? candidate.hodComments.approval : false;
                this.hodEmail = candidate.hodEmail ? candidate.hodEmail : '';
                this.deanEmail = candidate.deanEmail ? candidate.deanEmail : '';
                this.deanComments = candidate.deanComments ? candidate.deanComments.comment : '';
                this.deanCommentDate = candidate.deanComments ? candidate.deanComments.date : '';
                this.deanApproval = candidate.deanComments ? candidate.deanComments.approval : '';
                this.submitToDeanDate = candidate.submitToDeanDate ? candidate.submitToDeanDate : '';
            }

            this.$emit('toggleLoader');
        }
    }
}
</script>